<template>
  <div class="CATEGORY_NAME">
    <label for="" class="input-wrap">
      <input :value="category.id" type="text" hidden />
      <Input v-model="valuedata" type="text" disabled />
      <Icon type="ios-close" class="clear" @click.stop="clearInput" />
      <Icon type="ios-funnel-outline" class="funnel" v-if="isMultiple" @click.stop="openModal" />
      <i class="funnel ark-icon iconfont iconbj_xldan" v-if="!isMultiple" @click.stop="openModal" />
    </label>
    <Modal v-model="showTree" title="类目名称" :mask="true" closable footer-hide width="462" titleAlign="left">
      <div style="height: 60vh; overflow: auto" class="model__">
        <Input v-model="keyword" type="text" style="margin-bottom: 5px;" />
        <el-tree :props="props"
                 :data="data"
                 ref="tree"
                 :show-checkbox="isMultiple"
                 node-key="id"
                 @node-click="handleNodeClick"
                 @check-change="handleCheckChange"
                 :default-expanded-keys="expandedNode"
                 :default-checked-keys="checkedNode"
                 :filter-node-method="filterNode" />
      </div>
      <OmsButton :btn-config="btnConfig" class="modal-footer" />
    </Modal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import interceptorsModule from '@/config/interceptors'

export default {
  name: 'CategoryName',
  props: {
    isShowCheckbox: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object
    },
    isLastNode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      objid: -1,
      showTree: false,
      category: { id: '', name: '' }, // 当前选中商品品类
      keyword: '',
      // valuedata: "打底,打底上衣,打底上衣,打底裤类,打底裤类",
      valuedata: "",
      data: [],
      props: {
        label: 'title',
        children: 'children',
      },
      selectNodeTitle: [],
      // expandedNode: [138,180,201,181,202],
      // checkedNode: [138,180,201,181,202],
      expandedNode: [],
      checkedNode: [],
      count: 1,
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: $it('com.cancel'), // 取消
            btnclick: () => {
              this.showTree = false;
            },
          },
          {
            text: $it('com.determine'), // 确定
            type: 'primary',
            btnclick: () => {
              this.confirm()
            },
          },
        ],
      },
    };
  },
  async created() {
    await this.getTreeData();
    // 复制页面-商品品类初始化数据
    if (this.$route.params.itemId == 'New') {
      this.init()
    }
  },
  mounted() {
    setTimeout(() => {
      if (vm.$route.fullPath.includes('/SYSTEM/TABLE/')) {
        // 选中类目->查询条件联动->回显选中的类目
        const y = this.options
        if (y.refobjid) {
          this.valuedata = y.valuedata
          this.expandedNode = y.refobjid.split()
          this.checkedNode = y.refobjid.split()
          this.category.id = y.refobjid
          this.category.name = y.valuedata
        }
      }
    }, 1000);
    console.log(this.options)
    this.$on('formItemChange', (res) => {
      console.log('表单变更监听成功::')
      console.log(res)
    })
    // 详情页面-点击保存按钮，通知框架更新
    $('#actionMODIFY').on('click', () => {
      this.init()
    });
  },
  computed: {
    // 是否多选
    isMultiple: {
      get() {
        if (!this.isShowCheckbox) {
          return false
        } else if (!this.$route.params.hasOwnProperty('itemId')) {
          // 商品SPU列表批量修改- 单选
          return this.options.webconf && this.options.webconf.batchModal ? false : true
        }
      }
    }
  },
  watch: {
    keyword(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    ...mapMutations('customize', ['setCommodityCategoryId', 'setCurCategoryNode', 'setRelationId']),
    init() {
      const { tableName } = this.$route.params
      const copyTables = interceptorsModule.category.tableArr.copyTables
      if (copyTables.includes(tableName)) {
        this.$emit('change', String(this.category.id)); // 框架会以string格式处理，传number会报错，导致赋值有问题
      }
    },
    resetQueryForm() {
      // SPU列表 - 随'商品类目'的变更联动查询条件，联动完要把'商品类目'回显，该处用的方案是：将数据存在接口入参里,接口响应后从入参里数据赋值(全局搜'categoryEname')
      if (vm.$route.fullPath.includes('/SYSTEM/TABLE/') && ['PS_C_PRO','CP_C_WAREHOUSE','CP_C_RSTORE','CP_C_CUSTOMER'].includes(vm.$route.params.tableName)) {
        $('.ListsForm-button #cus-reset')[0].click()
      }
    },
    confirm() {
      const { singleObjectTables, QueryListTables } = interceptorsModule.category.tableArr
      if (!this.isMultiple) {
        const { tableName } = this.$route.params
        const lastLevelTables = singleObjectTables.filter(i => i != 'PS_C_CATEGORY')
        if (lastLevelTables.includes(tableName) || this.isLastNode) {
          // 单对象的商品品类只能选择末级
          if (this.category.children) {
            return this.$Message.warning('请选择末级节点！')
          }
          if (tableName == 'PS_C_PRO') {
            // 用于商品SPU单对象监听, 实时渲染商品属性Tab表单
            this.setCommodityCategoryId(this.category.id);
          }
        }
        this.valuedata = this.category.name || this.category.title
        this.$emit('change', this.category.id);
        this.showTree = false;
        // this.$Modal.remove();
        return
      }

      const handler = (key) => {
        return (this.$refs.tree.getCheckedNodes()).reduce((a,b) => {
          a.push(b[key])
          return a
        }, []);
      }

      // title回显在输入框
      const arr = handler('title');
      this.valuedata = arr.join()

      if (QueryListTables.includes(this.$route.params.tableName)) {
        // 列表查询传id
        const arrIds = handler('id');
        this.$emit('change', arrIds);
      } else {
        // 列表查询传title
        this.$emit('change', this.valuedata);
      }
      this.showTree = false;
      this.checkedNode = this.$refs.tree.getCheckedKeys() || []
      this.expandedNode = this.$refs.tree.getCheckedKeys() || []
      this.$route.params.tableName != 'PS_C_PRO' && this.resetQueryForm()
    },
    async getTreeData() {
      const self = this;
      const { itemId, tableName } = this.$route.params
      this.objid = itemId == undefined ? -1 : itemId == 'New' ? -1 : itemId
      const params = {
        id: this.objid,
        tableName
      }
      // 复制页面带入原明细id查类目列表
      const copyTables = interceptorsModule.category.tableArr.copyTables
      if (copyTables.includes(tableName) && itemId == 'New') {
        let copyId = sessionStorage.getItem(`${tableName}_definedForm_copy_itemId`)
        if (!!copyId) { // 是否是复制页面
          params.id = copyId
        }
      }
      const res = await self.service.basicData.getGoodsTypeTree(params)
      if (res.data.data.code == 0) {
        this.data = res.data.data.data;
        if (this.$route.params.hasOwnProperty('itemId')) {
          this.findCategory(this.data)
        }
      }
    },
    findCategory(data) {
      const { tableName } = this.$route.params
      data.forEach(i => {
        let isSelected = false
        // const tables = ['SG_C_TOC_STRATEGY', 'ST_C_PRO_LOGISTIC_STRATEGY']
        // if (tables.includes(tableName)) {
        //   isSelected = this.options.valuedata == i.id
        // } else {
        isSelected = i.selected
        // }
        if (isSelected) {
          this.valuedata = i.title
          this.category = { id: i.id, title: i.title, children: i.hasOwnProperty('children') }
          if (tableName == 'PS_C_CATEGORY') {
            this.setCurCategoryNode(i)
          }
          if (tableName == 'PS_C_PRO') {
            this.setCommodityCategoryId(this.category.id);
          }
        } else if (i.children && i.children.length){
          this.findCategory(i.children)
        }
      })
    },
    openModal() {
      if (!this.data.length) {
        this.getTreeData()
      }
      this.showTree = true;
    },
    clearInput() {
      if (!this.isMultiple) {
        switch (this.$route.params.tableName) {
          case 'PS_C_PRO':
            this.setCommodityCategoryId('')
            break;
          case 'PS_C_SKU':
            this.setRelationId('')
            break;
          case 'PS_C_CATEGORY':
            this.setCurCategoryNode({})
            break;
        }
      }
      this.category = { id: '', name: '', children: false }
      this.valuedata = ''
      this.$emit('change', undefined);
      this.checkedNode = []
      this.expandedNode = []
      this.resetQueryForm()
    },
    handleCheckChange(data, checked, indeterminate) {
      // 处理选中的title塞给查询接口
      /* if (checked) {
        this.selectNodeTitle.push(data.title)
      } else {
        this.selectNodeTitle.splice(
          this.selectNodeTitle.findIndex(i => i == data.title),
          1
        )
      } */
      // console.log(this.$refs.tree.getCheckedNodes());
      // console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      this.category = { id: String(data.id), name: data.title, children: data.hasOwnProperty('children') }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: 'region1' }, { name: 'region2' }]);
      }
      if (node.level > 3) return resolve([]);

      var hasChild;
      if (node.data.name === 'region1') {
        hasChild = true;
      } else if (node.data.name === 'region2') {
        hasChild = false;
      } else {
        hasChild = Math.random() > 0.5;
      }

      setTimeout(() => {
        var data;
        if (hasChild) {
          data = [
            {
              name: 'zone' + this.count++,
            },
            {
              name: 'zone' + this.count++,
            },
          ];
        } else {
          data = [];
        }

        resolve(data);
      }, 500);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    }
  },
};
</script>

<style lang="less">
.CATEGORY_NAME {
  .input-wrap {
    position: relative;
    .ark-input-wrapper {
    }
    .ark-icon {
      position: absolute;
      top: 3px;
      &.funnel {
        right: 1px;
      }
      &.clear {
        right: 20px;
      }
    }
  }
}
</style>
